import { ROLE_SUB_MERCHANT_ADMINISTRATOR } from './roles';

export const PortalAccess = Object.freeze({
  DEFAULT: 'DEFAULT',
  GREETLY_ONLY: 'GREETLY_ONLY',
  BOTH: 'BOTH',
});

export const getPortalAccess = ({ showGreetlyOnly, showGreetlyWithDetails }) => {
  if (showGreetlyWithDetails) return PortalAccess.BOTH;
  if (showGreetlyOnly) return PortalAccess.GREETLY_ONLY;
  return PortalAccess.DEFAULT;
};

export const getGreetlyMerchant = ({ role, currentUser }) => {
  if (!currentUser) return null;
  return role === ROLE_SUB_MERCHANT_ADMINISTRATOR
    ? currentUser.merchant || null
    : currentUser;
};

export const canAccessGreetly = (portalAccess, merchant) =>
  Boolean(merchant && merchant.isGreetlyEnable) &&
  (portalAccess === PortalAccess.GREETLY_ONLY ||
    portalAccess === PortalAccess.BOTH);

export const isGreetlyOnlyAccess = (portalAccess, merchant) =>
  Boolean(merchant && merchant.isGreetlyEnable) &&
  portalAccess === PortalAccess.GREETLY_ONLY;
